import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { TablerIconsModule } from 'angular-tabler-icons';
import { NavItem } from 'src/app/layouts/full/vertical/sidebar/nav-item/nav-item';
import { NavItemVisibilityService } from 'src/app/services/nav-item-visibility.service';
import { ATTENTION_NAV_ITEMS } from '../attention-nav-items';

@Component({
  selector: 'app-attention-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule, MatListModule, TablerIconsModule],
  templateUrl: './attention-sidebar.component.html',
  styleUrl: './attention-sidebar.component.scss',
})
export class AttentionSidebarComponent {
  @Output() itemNavigate = new EventEmitter<void>();

  readonly items = ATTENTION_NAV_ITEMS;

  constructor(
    private readonly router: Router,
    readonly visibility: NavItemVisibilityService
  ) {}

  isVisible(item: NavItem): boolean {
    return this.visibility.isVisible(item);
  }

  onLinkClick(): void {
    this.itemNavigate.emit();
  }

  isActive(item: NavItem): boolean {
    const path = this.router.url.split('?')[0].split('#')[0];
    if (item.activeRoutePrefixes?.length) {
      return item.activeRoutePrefixes.some((p) => path === p || path.startsWith(p + '/'));
    }
    if (!item.route) {
      return false;
    }
    const route = item.route.startsWith('/') ? item.route : `/${item.route}`;
    return this.router.isActive(route, {
      paths: 'subset',
      queryParams: 'ignored',
      fragment: 'ignored',
      matrixParams: 'ignored',
    });
  }
}
